import React from 'react';
import Contact from '../components/Contact';

function ContactPage() {
  return (
    <div style={{ paddingTop: '100px' }}>
      {/* Page Header */}
      <section style={{ padding: '3rem 0', background: 'linear-gradient(135deg, #0A1A2F 0%, #1a3a5f 100%)', color: '#fff' }}>
        <div className="container text-center">
          <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem', fontFamily: 'Montserrat' }}>Contact Us</h1>
          <p style={{ fontSize: '1.2rem', color: '#C9A44A' }}>We're Here to Help - 24/7 Support</p>
        </div>
      </section>

      <Contact />
      
      {/* Map Section Placeholder */}
      <section style={{ padding: '3rem 0', background: '#f8f9fa' }}>
        <div className="container">
          <h3 className="text-center mb-4" style={{ fontFamily: 'Montserrat' }}>Find Us on the Map</h3>
          <div style={{ 
            background: '#ddd', 
            height: '400px', 
            borderRadius: '15px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#666',
            fontSize: '1.2rem'
          }}>
            <p>Google Maps will be embedded here</p>
          </div>
        </div>
      </section>

      {/* Additional Contact Info */}
      <section style={{ padding: '5rem 0', background: '#0A1A2F', color: '#fff' }}>
        <div className="container text-center">
          <h2 className="section-title-white">Business Hours</h2>
          <div className="row" style={{ marginTop: '3rem' }}>
            <div className="col-md-4">
              <h5 style={{ color: '#C9A44A', marginBottom: '1rem' }}>Operations</h5>
              <p style={{ color: '#e0e0e0' }}>24/7 Available</p>
            </div>
            <div className="col-md-4">
              <h5 style={{ color: '#C9A44A', marginBottom: '1rem' }}>Office Hours</h5>
              <p style={{ color: '#e0e0e0' }}>Sunday - Thursday<br/>9:00 AM - 6:00 PM</p>
            </div>
            <div className="col-md-4">
              <h5 style={{ color: '#C9A44A', marginBottom: '1rem' }}>Emergency</h5>
              <p style={{ color: '#e0e0e0' }}>24/7 Support Line<br/>Available Always</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;